import { Grid } from "@mui/material";
import MultiFileSummary from "../Files/MultiFileSummary";
import config from "@poseidon/utils/config";

export const BoatFileManagementSection = ({ application, sx }) => (
  <Grid container spacing={2} mt={0} sx={sx}>
    {Object.entries(config.fileDisplay.boat).map(([key, title]) => (
      <Grid key={key} item xs={12} sm={6}>
        <MultiFileSummary
          link={`/applications/${application.id}/${key}/files`}
          fieldLabel={title}
        />
      </Grid>
    ))}
  </Grid>
);
